import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgColouredApple = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 14 14"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M5.66328 3.23077C6.27344 3.23077 7.03828 2.80356 7.49375 2.23395C7.90625 1.71774 8.20703 0.996822 8.20703 0.275906C8.20703 0.178004 8.19844 0.0801017 8.18125 0C7.50234 0.0267006 6.68594 0.47171 6.19609 1.06802C5.80938 1.52193 5.45703 2.23395 5.45703 2.96376C5.45703 3.07057 5.47422 3.17737 5.48281 3.21297C5.52578 3.22187 5.59453 3.23077 5.66328 3.23077ZM3.51484 14C4.34844 14 4.71797 13.4215 5.75781 13.4215C6.81484 13.4215 7.04687 13.9822 7.975 13.9822C8.88594 13.9822 9.49609 13.11 10.0719 12.2556C10.7164 11.2765 10.9828 10.3153 11 10.2708C10.9398 10.253 9.19531 9.5143 9.19531 7.44056C9.19531 5.64272 10.5703 4.8328 10.6477 4.7705C9.73672 3.41767 8.35312 3.38207 7.975 3.38207C6.95234 3.38207 6.11875 4.02289 5.59453 4.02289C5.02734 4.02289 4.27969 3.41767 3.39453 3.41767C1.71016 3.41767 0 4.8595 0 7.58296C0 9.274 0.635937 11.0629 1.41797 12.22C2.08828 13.199 2.67266 14 3.51484 14Z"
      fill="black"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgColouredApple)
const IconSvgColouredApple = createIcon(ForwardRef, 'SvgColouredApple')
export default IconSvgColouredApple
